import React from "react";

const PersonalisedTab = () => {
  return (
    <div
      className="absolute right-0 top-2 flex rounded-lg py-1"
      style={{
        background: "linear-gradient(268.49deg, #3779BB 0%, #87BCF1 100%)",
      }}
    >
      <img
        src="https://img.learntube.ai/public-assets/premium_1.svg?updatedAt=1689229408174"
        width={16}
        height={16}
        alt=""
        className="ml-2"
      />
      <p className="mx-2 text-[11px]">Personalised For You</p>
    </div>
  );
};

export default PersonalisedTab;
